import { Button, LogOutIcon, Stack } from '@fukuri-admins/ui/common';
import { useAuth } from '~/components/auth/AuthProvider';
import styles from './styles.module.scss';

type Props = {
  /** ログアウトボタンを表示するか（実施者ビルドのみ true を渡す） */
  showLogoutButton: boolean;
};

/**
 * ストレスチェックトップ画面のヘッダー
 *
 * タイトルと、実施者ビルド限定のログアウト動線をまとめて持つ。実施者ビルドでは
 * サイドメニューを非表示にしている（MMT-236）ため、その代替動線。
 * API を叩かないため `features/` ではなく `ui/domain/` に置いている。
 *
 * 出し分けは `IS_STRESS_CHECK_IMPLEMENTER_BUILD` を直接参照せず prop で受け取る。
 * 同定数はビルド時に静的置換されるため、内部で参照すると `.env` を読まない
 * Storybook の production build では常に false になり story で表示できない。
 *
 * バーは `PageHeader`（アクションのスロットを持たない）を使わず、同じトークンで
 * 自前に組んでいる。絶対配置で重ねずタイトルとボタンを flex の兄弟にするため
 * （`components/common/ContentsHeader` と同じ考え方）。`PageHeader` の変更には
 * 追従しないので、ヘッダーの見た目が変わったらこちらも合わせる必要がある。
 *
 * アイコンは `aria-hidden`。アクセシブル名は children から取る
 * （`aria-label` を付けると「ログアウトログアウト」になる）。
 */
export const StressAssessmentHeader: React.FC<Props> = ({ showLogoutButton }) => {
  const { signOut } = useAuth();

  return (
    <Stack
      direction='row'
      justifyContent='space-between'
      alignItems='center'
      className={styles.StressAssessmentHeader}
    >
      <span className={styles.Title}>ストレスチェック</span>
      {showLogoutButton && (
        <Button
          variant='ghost'
          type='button'
          size='md'
          onClick={signOut}
          icon={<LogOutIcon size='xs' aria-hidden />}
          iconPosition='left'
        >
          ログアウト
        </Button>
      )}
    </Stack>
  );
};
